// extracted by mini-css-extract-plugin
export default {"card":"BackgroundForm_card__o+6Dz","content":"BackgroundForm_content__3-S39"};